import { render, staticRenderFns } from "./user_invalidate_successfully.vue?vue&type=template&id=c9bfdfbe&scoped=true"
import script from "./user_invalidate_successfully.vue?vue&type=script&lang=js"
export * from "./user_invalidate_successfully.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bfdfbe",
  null
  
)

export default component.exports